import { Injectable } from '@angular/core';
import { RBACModel } from '@app/models/rbac/rbac.model';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

import { GisSharedService } from './gis.shared.service';

@Injectable({ providedIn: 'root' })
export class SharedService extends GisSharedService {

  constructor() {
    super();
  }

  private globalLocationValues: any;
  setLocationRatingPopup(frmGroupValues: any) { this.globalLocationValues = frmGroupValues; }
  getLocationRatingPopup(): any { return this.globalLocationValues; }

  private globalSearch$ = new Subject<any>();
  globalSearchValue = this.globalSearch$.asObservable();
  setGlobalSearchValue(searchValue: string) { this.globalSearch$.next(searchValue); }

  private globalSearchEntityData: any = null;
  setGlobalSearchEntityData(value) { this.globalSearchEntityData = value; }
  getGlobalSearchEntityData(): any { return this.globalSearchEntityData; }

  private globalSearchResult$: BehaviorSubject<[]>  = new BehaviorSubject(null);
  getGlobalSearchResult() { return this.globalSearchResult$; }
  setGlobalSearchResult(searchResult) { this.globalSearchResult$.next(searchResult); }

  private globalSearchPopOpen: BehaviorSubject<boolean>  = new BehaviorSubject(false);
  getglobalSearchPopOpenValue() { return this.globalSearchPopOpen; }
  setglobalSearchPopOpenValue(value) { this.globalSearchPopOpen.next(value); }

  private searchEntityData: any = [];
  getSearchEntityData() { return this.searchEntityData; }
  setSearchEntityData(value) { this.searchEntityData.push(value); }
  shiftSearchEntityData(){this.searchEntityData.shift();}

  private dashBoardOrigin: BehaviorSubject<number> = new BehaviorSubject(0);
  public updateTabIndex(index) { this.dashBoardOrigin.next(index); }
  getUpdateTabIndex(): Observable<any> { return this.dashBoardOrigin.asObservable(); }

  private getZoomValue$ = new Subject<any>();
  setZoomValue(value: number) { this.getZoomValue$.next(value); }
  getZoomValue(): Observable<any> { return this.getZoomValue$.asObservable(); }

  private getScrollValue$ = new Subject<any>();
  setScrollingValue(value: number) { this.getScrollValue$.next(value); }
  getScrollingValue(): Observable<any> { return this.getScrollValue$.asObservable(); }

  private getAssetInfoValue$ = new Subject<any>();
  setAssetInfoFlag(value: boolean) { this.getAssetInfoValue$.next(value); }
  getAssetInfoFlag(): Observable<any> { return this.getAssetInfoValue$.asObservable(); }

  public reloadAssignment$: BehaviorSubject<any> = new BehaviorSubject(null);
  getreloadAssignments(): Observable<any> { return this.reloadAssignment$.asObservable(); }

  public reloadPreviousCheckboxValue$: BehaviorSubject<any> = new BehaviorSubject(null);
  getpreviousCheckboxVlue(): Observable<any> { return this.reloadPreviousCheckboxValue$.asObservable(); }

  public getViewRoasterDetails$: BehaviorSubject<any> = new BehaviorSubject(null);
  getTeamRoasterList(): Observable<any> { return this.getViewRoasterDetails$.asObservable(); }

  list_to_tree(list) {
    let map = {}, node, roots = [], i;

    for (i = 0; i < list.length; i += 1) {
      map[list[i].questId] = i;
      list[i].children = [];
      list[i].answerId = null;
      list[i].answerText = null;
    }

    for (i = 0; i < list.length; i += 1) {
      node = list[i];
      if (node.linkId !== 0) {
        list[map[node.linkId]].children.push(node);
      } else {
        roots.push(node);
      }
    }

    const links = {
      aLinkId: 'answerA',
      bLinkId: 'answerB',
      cLinkId: 'answerC',
      dLinkId: 'answerD',
      eLinkId: 'answerE',
      fLinkId: 'answerF'
    }

    const updateNode = (parent) => {
      if (!parent?.children.length) {
        return;
      }
      for (const children of parent?.children) {
        const { questId } = children;
        const idLinkMap = Object.keys(links).reduce((total, each) => {
          total[parent[each]] = each;
          return total;
        }, {})
        if (idLinkMap[questId]) {
          children.toShowOnAnswer = parent[links[idLinkMap[questId]]];
        }
        updateNode(children);
      }
    }
    updateNode(roots[0]);
    return roots;
  }
  flat(array) {
    let result = [];
    array.forEach((a) => {
      result.push(a);
      if (Array.isArray(a.children)) {
        result = result.concat(this.flat(a.children));
      }
    });
    return result;
  }

  private selectedData$: BehaviorSubject<any> = new BehaviorSubject(null);
  getSelectedData(): Observable<any> {
    return this.selectedData$.asObservable();
  }
  setSelectedData(selected_object) {
    this.selectedData$.next(selected_object);
  }
  private saveSearchFilter: BehaviorSubject<boolean>  = new BehaviorSubject(false);
  getSaveSearchFilter() { return this.saveSearchFilter; }
  setSaveSearchFilter(searchResult) { this.saveSearchFilter.next(searchResult); }

   private sectionDisciplineMaster: BehaviorSubject<[]>  = new BehaviorSubject(null);
   getSectionDisciplineMaster() { return this.sectionDisciplineMaster; }
   setSectionDisciplineMaster(result) { this.sectionDisciplineMaster.next(result); }

   private additionalLayer =  new BehaviorSubject<any>([]); 
   setAdditionalLayer(val){
       this.additionalLayer.next(val);
   }

   getAdditionalLayer(): Observable<any>{
      return this.additionalLayer;
   }
   
   public enableresetbtn = new BehaviorSubject<boolean>(false);

   public resetBaseMap = new BehaviorSubject<boolean>(false);
   
   public legendListDefault = new BehaviorSubject([]);
   public tempdefultlayers = new BehaviorSubject([]);

   private rbacAccess: BehaviorSubject<RBACModel>  = new BehaviorSubject(null);
   getRbacAccess() { return this.rbacAccess; }
   setRbacAccess(result) { this.rbacAccess.next(result); }
   
}